import type { ID } from '@octopus-do/octopus-project-core'
import { TinyPopover } from '@octopus-do/octopus-storybook'
import type React from 'react'
import { useReducer } from 'react'

import { TagColorMenu, TagsContent } from './components'
import { POPOVER_MAX_WIDTH, POPOVER_WIDTH } from './constants'
import { useTagsPopover } from './hooks'

interface Props extends React.PropsWithChildren {
  nodeId: ID
  // The pages a toggled tag goes onto.
  nodes: ID[]
}

const next = (epoch: number) => epoch + 1

// The page tags popover (figma 86192:880836) around its trigger: the tags
// button of the page toolbar or the tag chips on the page. Manage in a color
// menu closes it (a remount) on the way to the color library.
export const TagsPopover: React.FC<Props> = ({ children, nodeId, nodes }) => {
  const [epoch, close] = useReducer(next, 0)
  const { colorHex, picker, popover } = useTagsPopover(nodeId, nodes, close)

  return (
    <TinyPopover.Root
      colorHex={colorHex}
      colorMenu={TagColorMenu}
      content={TagsContent}
      key={epoch}
      maxWidth={POPOVER_MAX_WIDTH}
      picker={picker}
      width={POPOVER_WIDTH}
      {...popover}
    >
      {children}
    </TinyPopover.Root>
  )
}
